import { AlertCircle } from '@untitledui/icons';
import { Icon } from './Icon';
import { useGcsStore } from '../../store/useGcsStore';
import { selectVehicleMcErrorDescription } from '../../store/selectors/selectVehicleMcErrorDescription';
import { selectVehicleTakeoffProhibition } from '../../store/selectors/selectVehicleTakeoffProhibition';
import type { VehicleId } from '../../types/gcs/vehicle';

interface VehicleErrorIndicatorProps {
  gcsId: string;
  vehicleId: VehicleId;
}

export const VehicleErrorIndicator = ({ gcsId, vehicleId }: VehicleErrorIndicatorProps) => {
  const errorDescription = useGcsStore((state) => selectVehicleMcErrorDescription(state.data, gcsId, vehicleId));
  const takeoffProhibition = useGcsStore((state) => selectVehicleTakeoffProhibition(state.data, gcsId, vehicleId));

  const errors = [errorDescription, takeoffProhibition].filter((e): e is string => !!e);

  if (errors.length === 0) {
    return null;
  }

  return <Icon icon={AlertCircle} size={20} color='var(--color-error)' title={errors.join('\n')} />;
};
